module.exports = __webpack_public_path__ + "img/icon_ai_voice.004aedad.svg";